module.exports = __webpack_public_path__ + "static/media/portfolio1 (7).b220b734.jpeg";